import { Plugin } from "@ckeditor/ckeditor5-core";
import { ButtonView } from "@ckeditor/ckeditor5-ui";

import FileDocumentRemoveOutline from "./fileDocumentRemoveOutline.svg";

export default class DeleteReferenceContentUI extends Plugin {
  destroy() {
    console.debug("Removing listener for cde:deleteReferenceContent");
    this.editor.off("cde:deleteReferenceContent");
  }

  init() {
    const editor = this.editor;
    const t = editor.t;

    editor.ui.componentFactory.add("deleteReferenceContent", () => {
      const deleteReferenceContentButtonView = new ButtonView();

      deleteReferenceContentButtonView.set({
        icon: FileDocumentRemoveOutline,
        isEnabled: true,
        label: t("Delete Reference Passage"),
        tooltip: true,
      });

      deleteReferenceContentButtonView.on("execute", () => {
        editor.fire("cde:deleteReferenceContent");
      });
      editor.on("change:isReadOnly", (_event, _propertyName, value) => {
        deleteReferenceContentButtonView.isEnabled = !value;
      });

      return deleteReferenceContentButtonView;
    });
  }
}
